import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HomeGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    return new Promise((resolve) => {
      this.authService
        .hasValidSession()
        .then(() => {
          resolve(true);
        })
        .catch(e => {
          // When we couldn't validate the session somehow
          this.router.navigate(['public/login']);
          resolve(false);
        });
    });
  }
}
